import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { StatusBadge, PriorityBadge } from "../components/Badges";
import { SlaCountdown } from "../components/SlaCountdown";
import { Wrench, ChevronRight, MapPin } from "lucide-react";

export default function EngineerView() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/complaints").then((r) => setList(r.data)).finally(() => setLoading(false));
  }, []);

  const active = list.filter((c) => !["Resolved", "Closed"].includes(c.status));
  const done = list.filter((c) => ["Resolved", "Closed"].includes(c.status));

  const Card = ({ c }) => (
    <button
      onClick={() => navigate(`/complaints/${c.id}`)}
      data-testid={`my-job-${c.complaint_no}`}
      className="w-full text-left border border-border bg-white p-4 hover:border-klein transition-all duration-200"
    >
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs font-bold text-klein">{c.complaint_no}</span>
        <ChevronRight size={16} className="text-muted-foreground" />
      </div>
      <div className="font-heading font-bold mt-1">{c.issue_category}</div>
      <div className="text-sm text-muted-foreground">{c.customer_name} · {c.appliance_type}</div>
      <div className="flex items-center gap-1 text-xs text-muted-foreground mt-1"><MapPin size={12} /> {c.customer_mobile}</div>
      <div className="flex items-center gap-2 mt-3">
        <StatusBadge status={c.status} />
        <PriorityBadge priority={c.priority} />
      </div>
      {c.sla?.attend_seconds_left != null && (
        <div className="mt-3">
          <SlaCountdown label="Attend within" secondsLeft={c.sla.attend_seconds_left} paused={c.sla.attend_paused} />
        </div>
      )}
    </button>
  );

  return (
    <div className="p-5 sm:p-8 fade-up">
      <div className="flex items-center gap-2 mb-6">
        <Wrench size={22} className="text-klein" />
        <h1 className="font-heading text-3xl font-black tracking-tighter">My Jobs</h1>
      </div>

      {loading ? (
        <div className="text-muted-foreground">Loading…</div>
      ) : (
        <>
          <div className="label-caps text-muted-foreground mb-3">Active ({active.length})</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            {active.length === 0 ? <div className="text-sm text-muted-foreground">No active jobs assigned.</div>
              : active.map((c) => <Card key={c.id} c={c} />)}
          </div>

          {done.length > 0 && (
            <>
              <div className="label-caps text-muted-foreground mb-3">Completed ({done.length})</div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 opacity-75">
                {done.map((c) => <Card key={c.id} c={c} />)}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
